<template>
  <app-panel>
    <div slot="panel-header" class="app-panel-collapse-small__header">
      <label>{{title}}</label>
      <collapse-expand-dropdown
        :show-icon="true"
        @click-option="onCollapseExpandDropdownClick"
      />
    </div>
    <div slot="panel-body" class="app-panel-collapse-small__body">
      <slot name="filters" />
      <s-empty-list
        v-if="!value.length && !loading"
        class="app-panel-collapse-small__empty-list empty-list_no-padding"/>
      <s-loader v-if="loading"/>
      <div v-show="!loading && value.length">
        <company-panel
          v-for="company in value"
          :key="company.id"
          :value="company"
          :filter="filter"
          @collapsed-change="changeIndividualCollapse"
          @recognize-alarm="onRecognizeAlarm"
        />
      </div>
    </div>
  </app-panel>
</template>

<script>
import CollapseExpandDropdown from '@/components/buttons/CollapseExpandDropdown';
import CompanyPanel from './CompanyPanel';

export default {
  components: {
    CollapseExpandDropdown,
    CompanyPanel,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    onCollapseExpandDropdownClick(toExpand) {
      if (toExpand) {
        this.expandAll();
        return;
      }
      this.collapseAll();
    },
    expandAll() {
      this.$emit('expand-all', false);
    },
    collapseAll() {
      this.$emit('collapse-all', true);
    },
    changeIndividualCollapse(options) {
      this.$emit('collapse-change', options);
    },
    onRecognizeAlarm() {
      this.$emit('recognize-alarm');
    },
  },
};
</script>

<style lang="sass" scoped>
  .app-panel-collapse-small
    &__header
      display: flex
      justify-content: space-between
      align-items: center
    &__empty-list
      padding: 3rem 0 4rem 0
    &__body
      margin: 5px 0 15px
      .loading
        height: 40px
      ::v-deep .loading__spinner, .empty-list__loader
        font-size: 1.2rem
  ::v-deep
    .app-panel__body
      overflow: visible !important
</style>
